import React, { useContext, useEffect } from 'react';
import './App.css';
import Footer from './components/08-footer/Footer';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './components/09-Home/Home';
import ShribetsMarket from './components/10-ShribetsMarket/ShribetsMarket';
import ShribetsStarline from './components/13-ShribetsStarline/ShribetsStarline';
import PanaChart from './components/12-pana-chart/PanaChart';
import JodiChart from './components/11-jodi-chart/JodiChart';
import { LoaderContext } from './components/15-loader/LoaderProvider';
import Loader from './components/15-loader/Loader';

function App() {

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    });


  }, [pathname]);


  const { isLoading } = useContext(LoaderContext);

  return (

    <div className="App">

      {
        isLoading ? <Loader /> :

          <>

            <Routes>

              <Route path="/" element={<Home />} />
              <Route path="/market-result" element={<ShribetsMarket />} />
              <Route path="/starline" element={<ShribetsStarline />} />
              <Route path="/market-result/panachart/:id" element={<PanaChart />} />
              <Route path="/market-result/jodichart/:id" element={<JodiChart />} />

            </Routes>

            {/* <Footer /> */}

          </>   

      }

    </div>

  );
}

export default App;
